import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  hierarchicalData: any[] = [];

  report = [
    {
        "id": "652c29550c61a05a77a38f68",
        "userId": 1,
        "userType": "Admin",
        "userName": "Super Admin",
        "authMode": null,
        "userMobileNo": "9494951828",
        "userEmail": "anil.thota@anikinitek.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            8
        ],
        "roleName": [
            "Service Industry"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "params",
                        "description": "Params List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/predefinedParameter"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all/{cid}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 24,
                        "name": "status-info",
                        "description": "Status Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/all/{cid}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/{id}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/statusInfo/"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/statusInfo"
                            }
                        ]
                    },
                    {
                        "seqNo": 25,
                        "name": "services",
                        "description": "Define Service",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 27,
                        "name": "uom-conversion-list",
                        "description": "Uom Conversion List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "tax-master-list",
                        "description": "Tax Master List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "product-master-group-list",
                        "description": "Product Master Group List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "list-location",
                        "description": "List Location",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee",
                        "description": "Employee List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-type",
                        "description": "Employee Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "billing-term-list",
                        "description": "Billing Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "payment-term-list",
                        "description": "Payment Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 18,
                "groupName": "Plan Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "plan-definition",
                        "description": "Plan Definition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/palnInfo"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/planInfo/all/{cid}"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "task-filter",
                        "description": "Task Filter",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/filterByStatusAndUserIdAndDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-task-filter",
                        "description": "User Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{cid}/{userId}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "update-taskpriority-time",
                        "description": "Task Priority Time",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "customer-approval",
                        "description": "Pending For Approval",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo/getAllByLatestStatus/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "customer-interested-product",
                        "description": "Customer Interested Product",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "roles",
                        "description": "Roles",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "roles-controller",
                                "type": "POST",
                                "serverPrivilege": "/roles"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "create-user",
                        "description": "User Communication",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/addConversationByConversationId/{conversationId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationByUserId/{userId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationById{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-request",
                        "description": "Process Vendor Application",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-approve-list",
                        "description": "Approved Vendor List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-block-list",
                        "description": "Block Listed Vendors",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 19,
                        "name": "prodcut-composition",
                        "description": "Prodcut Composition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "POST",
                                "serverPrivilege": "/productComposition"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Client Job",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "all-client-job",
                        "description": "Client Job List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "client-job-controller",
                                "type": "GET",
                                "serverPrivilege": "/clientJob/all/{cid}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Survey Template Controller",
                "screenPrivilegeList": [
                    {
                        "seqNo": 17,
                        "name": "add-survey-master",
                        "description": "Add Survey Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-map",
                        "description": "Existing Customer Map",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-to-be-approved-list",
                        "description": "To-Be Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Client Docs",
                "screenPrivilegeList": [
                    {
                        "seqNo": 101,
                        "name": "client-doc",
                        "description": "Client Doc",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "access-privileges-requests",
                        "description": "Access Privileges Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Whatsapp Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 112,
                        "name": "create-template",
                        "description": "Create Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 113,
                        "name": "send-whatsapp-message",
                        "description": "Send Whatsapp Message",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f71",
        "userId": 74,
        "userType": "Dealer",
        "userName": "N06002 - LSN network",
        "authMode": null,
        "userMobileNo": "9666868509",
        "userEmail": "venkat11@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7b",
        "userId": 43,
        "userType": "Dealer",
        "userName": "020921_sri sai ram cable network",
        "authMode": null,
        "userMobileNo": "9348605888",
        "userEmail": "srinivas_lingoji@yahoo.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7c",
        "userId": 49,
        "userType": "Dealer",
        "userName": "027521_SV Broadband",
        "authMode": null,
        "userMobileNo": "8686587868",
        "userEmail": "eerlabalu@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f8a",
        "userId": 71,
        "userType": "Dealer",
        "userName": "N01001 - Khairthabad Star TV",
        "authMode": null,
        "userMobileNo": "9848072769",
        "userEmail": "kandulaudaykumar@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f8f",
        "userId": 98,
        "userType": "Technician",
        "userName": "mohammad Yousuf",
        "authMode": null,
        "userMobileNo": "9399922573",
        "userEmail": "mohammad@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 255,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f90",
        "userId": 2,
        "userType": "Admin",
        "userName": "A Naga Mani",
        "authMode": null,
        "userMobileNo": "9866190888",
        "userEmail": "anm@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f92",
        "userId": 15,
        "userType": "Technician",
        "userName": "Siva Naga Krishna G",
        "authMode": null,
        "userMobileNo": "7095283697",
        "userEmail": "gsiva@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f93",
        "userId": 22,
        "userType": "Technician",
        "userName": "Jagadish Kasthuri",
        "authMode": null,
        "userMobileNo": "9392939726",
        "userEmail": "jagadish@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f9e",
        "userId": 85,
        "userType": "Dealer",
        "userName": "N10005 - Hitech internet serivce",
        "authMode": null,
        "userMobileNo": "8801163111",
        "userEmail": "skasif134@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f69",
        "userId": 36,
        "userType": "Dealer",
        "userName": "010111_Speed Network",
        "authMode": null,
        "userMobileNo": "7702067425",
        "userEmail": "luckyr23@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6a",
        "userId": 39,
        "userType": "Dealer",
        "userName": "010188_Saketh Communication",
        "authMode": null,
        "userMobileNo": "9666671314",
        "userEmail": "ganesh.chr86@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6d",
        "userId": 60,
        "userType": "Dealer",
        "userName": "010823_Akanksha Internet Services",
        "authMode": null,
        "userMobileNo": "9849103241",
        "userEmail": "sairamesh2014@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6f",
        "userId": 72,
        "userType": "Dealer",
        "userName": "020928_Global Networks, kuntloor",
        "authMode": null,
        "userMobileNo": "8096061165",
        "userEmail": "jayanthkale84@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f73",
        "userId": 79,
        "userType": "Dealer",
        "userName": "N05002 - Rohini Broadband",
        "authMode": null,
        "userMobileNo": "9704968574",
        "userEmail": "anu.rao1979@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f74",
        "userId": 89,
        "userType": "Dealer",
        "userName": "023809 Sree Venkata Sai Communications ",
        "authMode": null,
        "userMobileNo": "9059948228",
        "userEmail": "santosh.guptha120010@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7e",
        "userId": 62,
        "userType": "Dealer",
        "userName": "N09011 Siri Networks",
        "authMode": null,
        "userMobileNo": "9490608000",
        "userEmail": "sandeepkanna100@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f80",
        "userId": 67,
        "userType": "Dealer",
        "userName": "021118_Sree Communication",
        "authMode": null,
        "userMobileNo": "9346112269",
        "userEmail": "sreesreedhar07@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f82",
        "userId": 75,
        "userType": "Dealer",
        "userName": "N02012-KR CABLE",
        "authMode": null,
        "userMobileNo": "9030210766",
        "userEmail": "akula.pentaiah@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f86",
        "userId": 27,
        "userType": "Admin",
        "userName": "Swetha Pilli",
        "authMode": null,
        "userMobileNo": "9704035697",
        "userEmail": "pswetha@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f88",
        "userId": 46,
        "userType": "Dealer",
        "userName": "022762_B K Network",
        "authMode": null,
        "userMobileNo": "9246537544",
        "userEmail": "gunrathi@yahoo.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f89",
        "userId": 47,
        "userType": "Dealer",
        "userName": "027516_Hi Tech Broad Band",
        "authMode": null,
        "userMobileNo": "9032552837",
        "userEmail": "kraju434@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f95",
        "userId": 25,
        "userType": "Technician",
        "userName": "Chiranjeevi Manda",
        "authMode": null,
        "userMobileNo": "9182093809",
        "userEmail": "chiranjeevi@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f96",
        "userId": 34,
        "userType": "Dealer",
        "userName": "Sri Sai Cable Networks",
        "authMode": null,
        "userMobileNo": "9640443769",
        "userEmail": "shailender222@yahoo.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f9a",
        "userId": 63,
        "userType": "Dealer",
        "userName": "010815_Scientific broadband",
        "authMode": null,
        "userMobileNo": "9700874513",
        "userEmail": "msrihadri@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38ff7",
        "userId": 236,
        "userType": "Admin",
        "userName": "Madhuri",
        "authMode": null,
        "userMobileNo": "9494158088",
        "userEmail": "madhuri@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 285,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f64",
        "userId": 3,
        "userType": "Admin",
        "userName": "Phani Krishna Ravi",
        "authMode": null,
        "userMobileNo": "9849669009",
        "userEmail": "phani@rvr.in",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f65",
        "userId": 6,
        "userType": "Technician",
        "userName": "Nandu Gandham",
        "authMode": null,
        "userMobileNo": "7981737181",
        "userEmail": "nandu@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f66",
        "userId": 10,
        "userType": "NWSupport",
        "userName": "Naveen Reddy Padamati",
        "authMode": null,
        "userMobileNo": "9494708976",
        "userEmail": "pnr@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6b",
        "userId": 42,
        "userType": "Dealer",
        "userName": "020920_OmSaiRam_Rural_Association",
        "authMode": null,
        "userMobileNo": "9848012407",
        "userEmail": "amma.bts777@yahoo.co.in",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f70",
        "userId": 73,
        "userType": "Dealer",
        "userName": "N10001-Ashritha Broadband Network",
        "authMode": null,
        "userMobileNo": "9666338587",
        "userEmail": "ashrithabroadband@gamial.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f77",
        "userId": 14,
        "userType": "Technician",
        "userName": "Niranjan Koppula",
        "authMode": null,
        "userMobileNo": "9000203719",
        "userEmail": "niranjank@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7a",
        "userId": 41,
        "userType": "Dealer",
        "userName": "020919_Yamjal Communication",
        "authMode": null,
        "userMobileNo": "909030425205",
        "userEmail": "chinna.konduri@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7d",
        "userId": 54,
        "userType": "Dealer",
        "userName": "010804_BANJARA BROADBAND",
        "authMode": null,
        "userMobileNo": "9246184709",
        "userEmail": "banjarabroadband@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f81",
        "userId": 70,
        "userType": "Dealer",
        "userName": "N05001 - Dhruva Broadband",
        "authMode": null,
        "userMobileNo": "9100719942",
        "userEmail": "mahi74769@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f8c",
        "userId": 78,
        "userType": "Dealer",
        "userName": "N02017 - Friends Communication",
        "authMode": null,
        "userMobileNo": "9848075161",
        "userEmail": "pjr.pvr9595@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f8d",
        "userId": 88,
        "userType": "Dealer",
        "userName": "L02011  jai sai ohm sai Maanikanta cable network",
        "authMode": null,
        "userMobileNo": "9908169454",
        "userEmail": "nmyadav16@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f91",
        "userId": 9,
        "userType": "Technician",
        "userName": "Eresha",
        "authMode": null,
        "userMobileNo": "9901642836",
        "userEmail": "earesha@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f94",
        "userId": 24,
        "userType": "Admin",
        "userName": "RVR Chairman",
        "authMode": null,
        "userMobileNo": "9849013320",
        "userEmail": "rvr@rvr.in",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f97",
        "userId": 37,
        "userType": "Dealer",
        "userName": "010180_AX Internet Services",
        "authMode": null,
        "userMobileNo": "9394738393",
        "userEmail": "mb9394738393@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f98",
        "userId": 40,
        "userType": "Dealer",
        "userName": "010301_santosh communications",
        "authMode": null,
        "userMobileNo": "9866051111",
        "userEmail": "fire_ice3456@yahoo.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f9b",
        "userId": 64,
        "userType": "Dealer",
        "userName": "N02011-Sri Sai Broadband",
        "authMode": null,
        "userMobileNo": "9700058901",
        "userEmail": "vtel9700@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f9d",
        "userId": 68,
        "userType": "Dealer",
        "userName": "021529_Nissar Communication",
        "authMode": null,
        "userMobileNo": "9347837998",
        "userEmail": "nisarcomm@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38fa0",
        "userId": 97,
        "userType": "Technician",
        "userName": "Venkata Swamy",
        "authMode": null,
        "userMobileNo": "9849249130",
        "userEmail": "venkatswamya@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f67",
        "userId": 23,
        "userType": "Technician",
        "userName": "Maqsood Syed",
        "authMode": null,
        "userMobileNo": "9948481218",
        "userEmail": "maqsood@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6c",
        "userId": 45,
        "userType": "Dealer",
        "userName": "022746_srikanth communications",
        "authMode": null,
        "userMobileNo": "9000854132",
        "userEmail": "baswapuramsri@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f6e",
        "userId": 69,
        "userType": "Dealer",
        "userName": "021580_Cyber Broadband-2",
        "authMode": null,
        "userMobileNo": "8019987902",
        "userEmail": "sayee.kumar007@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f72",
        "userId": 76,
        "userType": "Dealer",
        "userName": "N02013 - VISHWA COMPUTERS AND BROADBAND",
        "authMode": null,
        "userMobileNo": "9948931101",
        "userEmail": "nareshkumar112@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f78",
        "userId": 35,
        "userType": "Dealer",
        "userName": "Manasa Cable Networks",
        "authMode": null,
        "userMobileNo": "9391062794",
        "userEmail": "jittutech@yahoomail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f79",
        "userId": 38,
        "userType": "Dealer",
        "userName": "010184 - SV Communications",
        "authMode": null,
        "userMobileNo": "9603333058",
        "userEmail": "kumargoud_goud@yahoo.co.in",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f7f",
        "userId": 65,
        "userType": "Dealer",
        "userName": "020115_Sree Communication4",
        "authMode": null,
        "userMobileNo": "9346396699",
        "userEmail": "srinuroja89@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f99",
        "userId": 44,
        "userType": "Dealer",
        "userName": "020953_Pooja Communication",
        "authMode": null,
        "userMobileNo": "8885145599",
        "userEmail": "milkey5599@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "652c29550c61a05a77a38f9c",
        "userId": 66,
        "userType": "Dealer",
        "userName": "021115_SPR Broadband",
        "authMode": null,
        "userMobileNo": "9059825107",
        "userEmail": "majjis2@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6543c0d78ae352519719f9bf",
        "userId": 238,
        "userType": "Technician",
        "userName": "Nagesh FTTH",
        "authMode": 1,
        "userMobileNo": "9550518999",
        "userEmail": "knrfibernxt@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 2,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "65b0c4ea768b760861d68289",
        "userId": 250,
        "userType": "Technician",
        "userName": "M Prabhakar",
        "authMode": 1,
        "userMobileNo": "9121939475",
        "userEmail": "snlbroadband01@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 2,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "65bdefa507eaf5133471080a",
        "userId": 251,
        "userType": "Technician",
        "userName": "Rajesh KP",
        "authMode": 1,
        "userMobileNo": "9398389592",
        "userEmail": "kittur807@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 27,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "65d74e7a07eaf51334710efc",
        "userId": 252,
        "userType": "Technician",
        "userName": "M Venkatesh OFC",
        "authMode": 1,
        "userMobileNo": "9346764537",
        "userEmail": "sv.ofcservices@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 2,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "65f051e3897ae405256ef17a",
        "userId": 253,
        "userType": "Technician",
        "userName": "Prakash Svs OFC",
        "authMode": 1,
        "userMobileNo": "9346164546",
        "userEmail": "svofcservices@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 2,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "661f57f4ed8f10464a643358",
        "userId": 254,
        "userType": "Admin",
        "userName": "Suchitra Ch",
        "authMode": null,
        "userMobileNo": "9701782049",
        "userEmail": "suchitramudiraj20@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6672dac13f8b1112158d87d6",
        "userId": 255,
        "userType": "Admin",
        "userName": "Vamsi Krishna B",
        "authMode": 1,
        "userMobileNo": "7036642681",
        "userEmail": "vamsi@rvrmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 2,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "66d0843e936cd87a4ee56e83",
        "userId": 262,
        "userType": "CCExecutive",
        "userName": "Reshma Shaik",
        "authMode": 1,
        "userMobileNo": "6309139749",
        "userEmail": "shaikreshma0015@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "66d0847bb3bf5e54ae2b904c",
        "userId": 263,
        "userType": "CCExecutive",
        "userName": "Sherlyn T",
        "authMode": 1,
        "userMobileNo": "9182671691",
        "userEmail": "sweetymammu01@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "66d1ae5a936cd87a4ee57298",
        "userId": 264,
        "userType": "CCExecutive",
        "userName": "Rashmi P",
        "authMode": 1,
        "userMobileNo": "8210607277",
        "userEmail": "acct2@rvr.in",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "66eae8ddad75e00b0e5ebcf8",
        "userId": 266,
        "userType": "CCExecutive",
        "userName": "T.Tulasi devi",
        "authMode": 1,
        "userMobileNo": "9701606920",
        "userEmail": "tulasitorati@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "66eae908ad75e00b0e5ebcf9",
        "userId": 267,
        "userType": "CCExecutive",
        "userName": "N.Kanaka Malleswara Rao",
        "authMode": 1,
        "userMobileNo": "9182452202",
        "userEmail": "kanaka9424@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "670c83a1f7f3e43a08679929",
        "userId": 271,
        "userType": "Admin",
        "userName": "Service User",
        "authMode": 1,
        "userMobileNo": "5005005010",
        "userEmail": "service_user1@anikinitek.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            8
        ],
        "roleName": [
            "Service Industry"
        ],
        "reportsTo": null,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "params",
                        "description": "Params List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/predefinedParameter"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all/{cid}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 24,
                        "name": "status-info",
                        "description": "Status Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/all/{cid}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/{id}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/statusInfo/"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/statusInfo"
                            }
                        ]
                    },
                    {
                        "seqNo": 25,
                        "name": "services",
                        "description": "Define Service",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 27,
                        "name": "uom-conversion-list",
                        "description": "Uom Conversion List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "tax-master-list",
                        "description": "Tax Master List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "product-master-group-list",
                        "description": "Product Master Group List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "list-location",
                        "description": "List Location",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee",
                        "description": "Employee List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-type",
                        "description": "Employee Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "billing-term-list",
                        "description": "Billing Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "payment-term-list",
                        "description": "Payment Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 18,
                "groupName": "Plan Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "plan-definition",
                        "description": "Plan Definition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/palnInfo"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/planInfo/all/{cid}"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "task-filter",
                        "description": "Task Filter",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/filterByStatusAndUserIdAndDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-task-filter",
                        "description": "User Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{cid}/{userId}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "update-taskpriority-time",
                        "description": "Task Priority Time",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "customer-approval",
                        "description": "Pending For Approval",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo/getAllByLatestStatus/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "customer-interested-product",
                        "description": "Customer Interested Product",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "roles",
                        "description": "Roles",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "roles-controller",
                                "type": "POST",
                                "serverPrivilege": "/roles"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "create-user",
                        "description": "User Communication",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/addConversationByConversationId/{conversationId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationByUserId/{userId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationById{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-request",
                        "description": "Process Vendor Application",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-approve-list",
                        "description": "Approved Vendor List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-block-list",
                        "description": "Block Listed Vendors",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 19,
                        "name": "prodcut-composition",
                        "description": "Prodcut Composition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "POST",
                                "serverPrivilege": "/productComposition"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Client Job",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "all-client-job",
                        "description": "Client Job List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "client-job-controller",
                                "type": "GET",
                                "serverPrivilege": "/clientJob/all/{cid}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Survey Template Controller",
                "screenPrivilegeList": [
                    {
                        "seqNo": 17,
                        "name": "add-survey-master",
                        "description": "Add Survey Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-map",
                        "description": "Existing Customer Map",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-to-be-approved-list",
                        "description": "To-Be Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Client Docs",
                "screenPrivilegeList": [
                    {
                        "seqNo": 101,
                        "name": "client-doc",
                        "description": "Client Doc",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "access-privileges-requests",
                        "description": "Access Privileges Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Whatsapp Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 112,
                        "name": "create-template",
                        "description": "Create Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 113,
                        "name": "send-whatsapp-message",
                        "description": "Send Whatsapp Message",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "671cc8b7754db11c0dddc0d8",
        "userId": 272,
        "userType": "CCExecutive",
        "userName": "Vaddi Varun ",
        "authMode": 1,
        "userMobileNo": "9030111732",
        "userEmail": "vaddivarun192@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            8
        ],
        "roleName": [
            "Service Industry"
        ],
        "reportsTo": 236,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "params",
                        "description": "Params List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/predefinedParameter"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all/{cid}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 24,
                        "name": "status-info",
                        "description": "Status Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/all/{cid}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/statusInfo/{id}"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/statusInfo/"
                            },
                            {
                                "controllerName": "status-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/statusInfo"
                            }
                        ]
                    },
                    {
                        "seqNo": 25,
                        "name": "services",
                        "description": "Define Service",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 27,
                        "name": "uom-conversion-list",
                        "description": "Uom Conversion List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "tax-master-list",
                        "description": "Tax Master List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "product-master-group-list",
                        "description": "Product Master Group List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "list-location",
                        "description": "List Location",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee",
                        "description": "Employee List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-type",
                        "description": "Employee Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "billing-term-list",
                        "description": "Billing Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "payment-term-list",
                        "description": "Payment Term List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 18,
                "groupName": "Plan Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "plan-definition",
                        "description": "Plan Definition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/palnInfo"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/planInfo/all/{cid}"
                            },
                            {
                                "controllerName": "plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "task-filter",
                        "description": "Task Filter",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/filterByStatusAndUserIdAndDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-task-filter",
                        "description": "User Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{cid}/{userId}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "update-taskpriority-time",
                        "description": "Task Priority Time",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "customer-approval",
                        "description": "Pending For Approval",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo/getAllByLatestStatus/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "PUT",
                                "serverPrivilege": "/customerInfo/updateStatus"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "customer-interested-product",
                        "description": "Customer Interested Product",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "roles",
                        "description": "Roles",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "roles-controller",
                                "type": "POST",
                                "serverPrivilege": "/roles"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "create-user",
                        "description": "User Communication",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/addConversationByConversationId/{conversationId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationByUserId/{userId}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/ConversationById{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-request",
                        "description": "Process Vendor Application",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-approve-list",
                        "description": "Approved Vendor List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-block-list",
                        "description": "Block Listed Vendors",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 19,
                        "name": "prodcut-composition",
                        "description": "Prodcut Composition",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "POST",
                                "serverPrivilege": "/productComposition"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/all/{cid}"
                            },
                            {
                                "controllerName": "prodcut-composition-controller",
                                "type": "GET",
                                "serverPrivilege": "/productComposition/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Client Job",
                "screenPrivilegeList": [
                    {
                        "seqNo": 2,
                        "name": "all-client-job",
                        "description": "Client Job List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "client-job-controller",
                                "type": "GET",
                                "serverPrivilege": "/clientJob/all/{cid}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 23,
                "groupName": "Survey Template Controller",
                "screenPrivilegeList": [
                    {
                        "seqNo": 17,
                        "name": "add-survey-master",
                        "description": "Add Survey Master",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-map",
                        "description": "Existing Customer Map",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ec-to-be-approved-list",
                        "description": "To-Be Approved List",
                        "add": false,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Client Docs",
                "screenPrivilegeList": [
                    {
                        "seqNo": 101,
                        "name": "client-doc",
                        "description": "Client Doc",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "access-privileges-requests",
                        "description": "Access Privileges Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 0,
                "groupName": "Whatsapp Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 112,
                        "name": "create-template",
                        "description": "Create Template",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 113,
                        "name": "send-whatsapp-message",
                        "description": "Send Whatsapp Message",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674968eb72503b5f7730baf0",
        "userId": 279,
        "userType": "Customer",
        "userName": "Ranjith",
        "authMode": null,
        "userMobileNo": "9032305268",
        "userEmail": "9032305268@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674a8d9772503b5f7730bdc0",
        "userId": 282,
        "userType": "Admin",
        "userName": "P Srinivasa Gouda",
        "authMode": 1,
        "userMobileNo": "9000660846",
        "userEmail": "srinivasgoud6175@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 257,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674aa54372503b5f7730be9f",
        "userId": 283,
        "userType": "Customer",
        "userName": "B.Raghavendra",
        "authMode": null,
        "userMobileNo": "9052742427",
        "userEmail": "raghuveer.rokey@gamil",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674aa6b272503b5f7730bead",
        "userId": 284,
        "userType": "Customer",
        "userName": "Likitha",
        "authMode": null,
        "userMobileNo": "9849735044",
        "userEmail": "mamidilikitha.sonu@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674ab2b772503b5f7730bf4d",
        "userId": 285,
        "userType": "Admin",
        "userName": "Naveen D",
        "authMode": null,
        "userMobileNo": "9063429835",
        "userEmail": "jaisriram95052@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 2,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674ab54872503b5f7730c04f",
        "userId": 286,
        "userType": "Customer",
        "userName": "Praveen",
        "authMode": null,
        "userMobileNo": "8374498660",
        "userEmail": "Praveengoud852@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674ac42872503b5f7730c0ee",
        "userId": 287,
        "userType": "Customer",
        "userName": "Abhishek",
        "authMode": null,
        "userMobileNo": "6302221510",
        "userEmail": "Makalaabhishek@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674d56d28c80380aac1a4781",
        "userId": 288,
        "userType": "Customer",
        "userName": "Sujatha",
        "authMode": null,
        "userMobileNo": "9177577870",
        "userEmail": "kaliwaladincal6976@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674ec060359094297f884653",
        "userId": 289,
        "userType": "Customer",
        "userName": "Kurra mallaiah",
        "authMode": null,
        "userMobileNo": "9848156582",
        "userEmail": "Kurramallesh99@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "674ede488c80380aac1a4fdf",
        "userId": 290,
        "userType": "Customer",
        "userName": "Ashritha Broadband Network",
        "authMode": null,
        "userMobileNo": "9666338587",
        "userEmail": "Ashritha Broadband Network@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675003338c80380aac1a54d4",
        "userId": 291,
        "userType": "Customer",
        "userName": "satish kumar",
        "authMode": null,
        "userMobileNo": "8500343277",
        "userEmail": "satish kumar",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675278871274154061b53eae",
        "userId": 292,
        "userType": "NWSupport",
        "userName": "M.Vamsi ",
        "authMode": 1,
        "userMobileNo": "9063429837",
        "userEmail": "vamsimarturi56@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 285,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e7d2a411de445963e1ed",
        "userId": 293,
        "userType": "Customer",
        "userName": "nageswara rao gokul",
        "authMode": null,
        "userMobileNo": "6303347759",
        "userEmail": "6303347759@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e832a411de445963e1f2",
        "userId": 294,
        "userType": "Customer",
        "userName": "prabhu kishore",
        "authMode": null,
        "userMobileNo": "9182978637",
        "userEmail": "9182978637@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e878a411de445963e1f7",
        "userId": 295,
        "userType": "Customer",
        "userName": "Pawan ",
        "authMode": null,
        "userMobileNo": "8179616265",
        "userEmail": "8179616265@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e8c8a411de445963e1fb",
        "userId": 296,
        "userType": "Customer",
        "userName": " Ganesh",
        "authMode": null,
        "userMobileNo": "6301851773",
        "userEmail": "6301851773@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e91fa411de445963e1ff",
        "userId": 297,
        "userType": "Customer",
        "userName": "Abdul",
        "authMode": null,
        "userMobileNo": "7799170930",
        "userEmail": "7799170930@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e96aa411de445963e203",
        "userId": 298,
        "userType": "Customer",
        "userName": "madhuri",
        "authMode": null,
        "userMobileNo": "9912833696",
        "userEmail": "9912833696@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753e9c4a411de445963e207",
        "userId": 299,
        "userType": "Customer",
        "userName": "Vikas Goud D",
        "authMode": null,
        "userMobileNo": "9182839897",
        "userEmail": "9182839897@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753ea1da411de445963e20b",
        "userId": 300,
        "userType": "Customer",
        "userName": "Rakesh",
        "authMode": null,
        "userMobileNo": "6304913626",
        "userEmail": "6304913626@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753ea6aa411de445963e217",
        "userId": 301,
        "userType": "Customer",
        "userName": "ilayya",
        "authMode": null,
        "userMobileNo": "9640647183",
        "userEmail": "9640647183@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f40ca411de445963e365",
        "userId": 302,
        "userType": "Customer",
        "userName": "maikanta",
        "authMode": null,
        "userMobileNo": "9502034962",
        "userEmail": "9502034962@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f47ca411de445963e371",
        "userId": 303,
        "userType": "Customer",
        "userName": "Nikhil",
        "authMode": null,
        "userMobileNo": "8008529296",
        "userEmail": "Koheda",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f584a411de445963e378",
        "userId": 304,
        "userType": "Customer",
        "userName": "Sagar",
        "authMode": null,
        "userMobileNo": "9000605992",
        "userEmail": "9000605992@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f5d01274154061b5499f",
        "userId": 305,
        "userType": "Customer",
        "userName": "Shiva",
        "authMode": null,
        "userMobileNo": "7093180389",
        "userEmail": "7093180389@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f6841274154061b549a3",
        "userId": 306,
        "userType": "Customer",
        "userName": "Chandu",
        "authMode": null,
        "userMobileNo": "7993821972",
        "userEmail": "7993821972@gamial.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f74aa411de445963e39a",
        "userId": 307,
        "userType": "Customer",
        "userName": "Mani Kumar",
        "authMode": null,
        "userMobileNo": "9010374977",
        "userEmail": "9010374977@gamail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6753f824a411de445963e3b9",
        "userId": 308,
        "userType": "Customer",
        "userName": "pavan kumar",
        "authMode": null,
        "userMobileNo": "9848805808",
        "userEmail": "9848805808@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675405cda411de445963e43c",
        "userId": 309,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9294578568",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540661a411de445963e440",
        "userId": 310,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9246597374",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540671a411de445963e445",
        "userId": 311,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "6281180519",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540681a411de445963e44b",
        "userId": 312,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8499844241",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406ada411de445963e44f",
        "userId": 313,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9533739381",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406b7a411de445963e453",
        "userId": 314,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9949903334",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406c3a411de445963e457",
        "userId": 315,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9848814739",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406d41274154061b54a5c",
        "userId": 316,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9542866956",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406df1274154061b54a60",
        "userId": 317,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9100389862",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675406efa411de445963e45b",
        "userId": 318,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7702775874",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540704a411de445963e45f",
        "userId": 319,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "6381741365",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6754070da411de445963e463",
        "userId": 320,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7013615065",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540718a411de445963e467",
        "userId": 321,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7036895189",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540727a411de445963e46c",
        "userId": 322,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9975155548",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540753a411de445963e472",
        "userId": 323,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9052118866",
        "userEmail": "9294578568@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675407b31274154061b54a64",
        "userId": 324,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7095344625",
        "userEmail": "7095344625@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675408b21274154061b54a9c",
        "userId": 325,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9908232925",
        "userEmail": "9908232925@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540936a411de445963e4da",
        "userId": 326,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7981473821",
        "userEmail": "7981473821@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675409a41274154061b54ac1",
        "userId": 327,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7995753271",
        "userEmail": "7995753271@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675409be1274154061b54ac5",
        "userId": 328,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9573515226",
        "userEmail": "9573515226@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675409eba411de445963e513",
        "userId": 329,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9553399990",
        "userEmail": "9553399990@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540a04a411de445963e517",
        "userId": 330,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7093040045",
        "userEmail": "7093040045@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540a211274154061b54ac9",
        "userId": 331,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9652534705",
        "userEmail": "9652534705@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540a56a411de445963e51b",
        "userId": 332,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9908804274",
        "userEmail": "9908804274@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540a68a411de445963e51f",
        "userId": 333,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9390399603",
        "userEmail": "9390399603@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540a92a411de445963e523",
        "userId": 334,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "6281054204",
        "userEmail": "6281054204@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540ac1a411de445963e527",
        "userId": 335,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8639875203",
        "userEmail": "8639875203@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540b061274154061b54ace",
        "userId": 336,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7799814477",
        "userEmail": "7799814477@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540b17a411de445963e52b",
        "userId": 337,
        "userType": "Customer",
        "userName": "G Satya Sai kimar",
        "authMode": null,
        "userMobileNo": "8143500834",
        "userEmail": "8143500834@gamail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540b70a411de445963e533",
        "userId": 338,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9966315674",
        "userEmail": "9966315674@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540b9d1274154061b54ad5",
        "userId": 339,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9010862261",
        "userEmail": "9010862261@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67540bbf1274154061b54ad9",
        "userId": 340,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9849820144",
        "userEmail": "9849820144@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541944a411de445963e555",
        "userId": 341,
        "userType": "Customer",
        "userName": "Shiva ",
        "authMode": null,
        "userMobileNo": "9963486018",
        "userEmail": "9963486018",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6754196da411de445963e55d",
        "userId": 342,
        "userType": "Customer",
        "userName": "Aravind",
        "authMode": null,
        "userMobileNo": "8247690721",
        "userEmail": "8247690721@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541982a411de445963e576",
        "userId": 343,
        "userType": "Customer",
        "userName": "Ravi",
        "authMode": null,
        "userMobileNo": "8790524217",
        "userEmail": "8790524217",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675419a5a411de445963e58a",
        "userId": 344,
        "userType": "Customer",
        "userName": "Chary ",
        "authMode": null,
        "userMobileNo": "9948735955",
        "userEmail": "9948735955",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675419aaa411de445963e58e",
        "userId": 345,
        "userType": "Customer",
        "userName": "sai",
        "authMode": null,
        "userMobileNo": "8367450234",
        "userEmail": "8247690721@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675419b5a411de445963e592",
        "userId": 346,
        "userType": "Customer",
        "userName": "Sai Charan",
        "authMode": null,
        "userMobileNo": "8897274802",
        "userEmail": "8897274802@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675419ec1274154061b54b31",
        "userId": 347,
        "userType": "Customer",
        "userName": "Rajakumar",
        "authMode": null,
        "userMobileNo": "8801708764",
        "userEmail": "byrirajakumar@yahoo.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a17a411de445963e59c",
        "userId": 348,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9985531286",
        "userEmail": "9985531286@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a321274154061b54b4a",
        "userId": 349,
        "userType": "Customer",
        "userName": "VISHAL",
        "authMode": null,
        "userMobileNo": "8106798467",
        "userEmail": "8106798467@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a36a411de445963e5a0",
        "userId": 350,
        "userType": "Customer",
        "userName": "hemanth",
        "authMode": null,
        "userMobileNo": "9640852978",
        "userEmail": "9640852978@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a4ea411de445963e5b4",
        "userId": 351,
        "userType": "Customer",
        "userName": "ramu",
        "authMode": null,
        "userMobileNo": "9553414382",
        "userEmail": "9553414382@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a541274154061b54b4e",
        "userId": 352,
        "userType": "Customer",
        "userName": "Azad ",
        "authMode": null,
        "userMobileNo": "9392234244",
        "userEmail": "9392234244",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a671274154061b54b52",
        "userId": 353,
        "userType": "Customer",
        "userName": "sai",
        "authMode": null,
        "userMobileNo": "9052850956",
        "userEmail": "9052850956@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541a9e1274154061b54b59",
        "userId": 354,
        "userType": "Customer",
        "userName": "tharun",
        "authMode": null,
        "userMobileNo": "8328003017",
        "userEmail": "8328003017@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ac71274154061b54b5d",
        "userId": 355,
        "userType": "Customer",
        "userName": "naveen",
        "authMode": null,
        "userMobileNo": "9133543136",
        "userEmail": "9133543136@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541acd1274154061b54b61",
        "userId": 356,
        "userType": "Customer",
        "userName": "Anirudh",
        "authMode": null,
        "userMobileNo": "9640249795",
        "userEmail": "myselfmad16@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541af41274154061b54b65",
        "userId": 357,
        "userType": "Customer",
        "userName": "aebaaz",
        "authMode": null,
        "userMobileNo": "7337071572",
        "userEmail": "7337071572@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b15a411de445963e5b8",
        "userId": 358,
        "userType": "Customer",
        "userName": "Ravi",
        "authMode": null,
        "userMobileNo": "9030626297",
        "userEmail": "9030626297@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b221274154061b54b69",
        "userId": 359,
        "userType": "Customer",
        "userName": "mosin",
        "authMode": null,
        "userMobileNo": "7093230319",
        "userEmail": "7093230319@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b5c1274154061b54b6d",
        "userId": 360,
        "userType": "Customer",
        "userName": "aritel",
        "authMode": null,
        "userMobileNo": "9392637495",
        "userEmail": "9392637495@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b691274154061b54b71",
        "userId": 361,
        "userType": "Customer",
        "userName": "Abdul Sameer",
        "authMode": null,
        "userMobileNo": "9885571515",
        "userEmail": "9885571515@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b84a411de445963e5bf",
        "userId": 362,
        "userType": "Customer",
        "userName": "Lokesh",
        "authMode": null,
        "userMobileNo": "8247896351",
        "userEmail": "8247896351",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541b84a411de445963e5c0",
        "userId": 363,
        "userType": "Customer",
        "userName": "mahesh babu",
        "authMode": null,
        "userMobileNo": "9381983685",
        "userEmail": "9381983685@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541bae1274154061b54b75",
        "userId": 364,
        "userType": "Customer",
        "userName": "Qadeer",
        "authMode": null,
        "userMobileNo": "9885078699",
        "userEmail": "9885078699",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541bafa411de445963e5c4",
        "userId": 365,
        "userType": "Customer",
        "userName": "jaya",
        "authMode": null,
        "userMobileNo": "6300795652",
        "userEmail": "6300795652@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541bd31274154061b54b79",
        "userId": 366,
        "userType": "Customer",
        "userName": "Srilekha",
        "authMode": null,
        "userMobileNo": "7674078870",
        "userEmail": "7674078870",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541bdc1274154061b54b7d",
        "userId": 367,
        "userType": "Customer",
        "userName": "cherry",
        "authMode": null,
        "userMobileNo": "9848393030",
        "userEmail": "9848393030@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541bf21274154061b54b81",
        "userId": 368,
        "userType": "Customer",
        "userName": "Krishna",
        "authMode": null,
        "userMobileNo": "8712292816",
        "userEmail": "8712292816",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c011274154061b54b85",
        "userId": 369,
        "userType": "Customer",
        "userName": "subhani",
        "authMode": null,
        "userMobileNo": "9949652976",
        "userEmail": "smsubhani26@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c021274154061b54b89",
        "userId": 370,
        "userType": "Customer",
        "userName": "jashua",
        "authMode": null,
        "userMobileNo": "9550825491",
        "userEmail": "9550825491@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c0ca411de445963e5c9",
        "userId": 371,
        "userType": "Customer",
        "userName": "Pallavi",
        "authMode": null,
        "userMobileNo": "6304044539",
        "userEmail": "6304044539@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c1d1274154061b54b8d",
        "userId": 372,
        "userType": "Customer",
        "userName": "E.Dasharatham.",
        "authMode": null,
        "userMobileNo": "8106825177",
        "userEmail": "8106825177",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c2aa411de445963e5cd",
        "userId": 373,
        "userType": "Customer",
        "userName": "dileep",
        "authMode": null,
        "userMobileNo": "8688222994",
        "userEmail": "8688222994@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c461274154061b54b96",
        "userId": 374,
        "userType": "Customer",
        "userName": "Uday Kiran",
        "authMode": null,
        "userMobileNo": "7794800566",
        "userEmail": "pandalaudaykiran@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c46a411de445963e5e5",
        "userId": 375,
        "userType": "Customer",
        "userName": "Varsha",
        "authMode": null,
        "userMobileNo": "8340049813",
        "userEmail": "8340049813",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c5fa411de445963e5eb",
        "userId": 376,
        "userType": "Customer",
        "userName": "gayathri",
        "authMode": null,
        "userMobileNo": "8143860905",
        "userEmail": "gayu0464@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c6ba411de445963e5ef",
        "userId": 377,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9000231319",
        "userEmail": "9000231319@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c711274154061b54bae",
        "userId": 378,
        "userType": "Customer",
        "userName": "Karnakar",
        "authMode": null,
        "userMobileNo": "6305496886",
        "userEmail": "6305496886",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c8c1274154061b54bc7",
        "userId": 379,
        "userType": "Customer",
        "userName": "sukumar",
        "authMode": null,
        "userMobileNo": "9440506889",
        "userEmail": "9440506889@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541c91a411de445963e5f3",
        "userId": 380,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8309458952",
        "userEmail": "8309458952@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ca0a411de445963e5f7",
        "userId": 381,
        "userType": "Customer",
        "userName": "Prem",
        "authMode": null,
        "userMobileNo": "9550279501",
        "userEmail": "9550279501",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cb1a411de445963e5fc",
        "userId": 382,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9133607105",
        "userEmail": "9133607105@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cb3a411de445963e600",
        "userId": 383,
        "userType": "Customer",
        "userName": "sai",
        "authMode": null,
        "userMobileNo": "7730824361",
        "userEmail": "7730824361@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cb7a411de445963e605",
        "userId": 384,
        "userType": "Customer",
        "userName": "R jyothi babu",
        "authMode": null,
        "userMobileNo": "9494444962",
        "userEmail": "9494444962@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cc51274154061b54bd1",
        "userId": 385,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8309991885",
        "userEmail": "8309991885@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cdba411de445963e609",
        "userId": 386,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7288945908",
        "userEmail": "7288945908@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541cfaa411de445963e60d",
        "userId": 387,
        "userType": "Customer",
        "userName": "prasad",
        "authMode": null,
        "userMobileNo": "9502161415",
        "userEmail": "9502161415@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d061274154061b54bd5",
        "userId": 388,
        "userType": "Customer",
        "userName": "Avinash",
        "authMode": null,
        "userMobileNo": "9581298939",
        "userEmail": "9581298939",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d11a411de445963e621",
        "userId": 389,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7386286487",
        "userEmail": "7386286487@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d261274154061b54bd9",
        "userId": 390,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9346196489",
        "userEmail": "9346196489@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d2b1274154061b54bdd",
        "userId": 391,
        "userType": "Customer",
        "userName": "arjun",
        "authMode": null,
        "userMobileNo": "9963698841",
        "userEmail": "9963698841@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d3b1274154061b54be1",
        "userId": 392,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9666901220",
        "userEmail": "9666901220@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d52a411de445963e635",
        "userId": 393,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9542892962",
        "userEmail": "9542892962@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d531274154061b54bf5",
        "userId": 394,
        "userType": "Customer",
        "userName": "sunitha",
        "authMode": null,
        "userMobileNo": "7794935443",
        "userEmail": "7794935443@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d621274154061b54bf9",
        "userId": 395,
        "userType": "Customer",
        "userName": "Tejaswini",
        "authMode": null,
        "userMobileNo": "9154718541",
        "userEmail": "9154718541@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d6e1274154061b54bfd",
        "userId": 396,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8328699728",
        "userEmail": "8328699728@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d791274154061b54c01",
        "userId": 397,
        "userType": "Customer",
        "userName": "dhanu ",
        "authMode": null,
        "userMobileNo": "7097053524",
        "userEmail": "7097053524@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541d99a411de445963e63d",
        "userId": 398,
        "userType": "Customer",
        "userName": "yogesh",
        "authMode": null,
        "userMobileNo": "6302510428",
        "userEmail": "6302510428@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541da7a411de445963e641",
        "userId": 399,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7671031638",
        "userEmail": "7671031638@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541dc3a411de445963e645",
        "userId": 400,
        "userType": "Customer",
        "userName": "Vikas\t",
        "authMode": null,
        "userMobileNo": "9700070000",
        "userEmail": "9700070000@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541dc61274154061b54c16",
        "userId": 401,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8143937292",
        "userEmail": "8143937292@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541dd7a411de445963e649",
        "userId": 402,
        "userType": "Customer",
        "userName": "araja",
        "authMode": null,
        "userMobileNo": "9985865333",
        "userEmail": "9985865333@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541de31274154061b54c1a",
        "userId": 403,
        "userType": "Customer",
        "userName": "Ganesh",
        "authMode": null,
        "userMobileNo": "9666187155",
        "userEmail": "9666187155",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541dea1274154061b54c1e",
        "userId": 404,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9014347093",
        "userEmail": "9014347093@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e011274154061b54c25",
        "userId": 405,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7671895843",
        "userEmail": "7671895843@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e0e1274154061b54c2a",
        "userId": 406,
        "userType": "Customer",
        "userName": "bhavana",
        "authMode": null,
        "userMobileNo": "8125819283",
        "userEmail": "8125819283@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e33a411de445963e662",
        "userId": 407,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8712128118",
        "userEmail": "8712128118@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e3da411de445963e666",
        "userId": 408,
        "userType": "Customer",
        "userName": "Yeshwanth",
        "authMode": null,
        "userMobileNo": "7995319495",
        "userEmail": "yeshwanthgoud2345@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e5e1274154061b54c4e",
        "userId": 409,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7386641510",
        "userEmail": "7386641510@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e78a411de445963e66c",
        "userId": 410,
        "userType": "Customer",
        "userName": "kumar",
        "authMode": null,
        "userMobileNo": "9394859530",
        "userEmail": "9394859530@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541e831274154061b54c54",
        "userId": 411,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9014770860",
        "userEmail": "9014770860@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ea4a411de445963e670",
        "userId": 412,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7989495959",
        "userEmail": "7989495959@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ea91274154061b54c68",
        "userId": 413,
        "userType": "Customer",
        "userName": "bhagi",
        "authMode": null,
        "userMobileNo": "9704793638",
        "userEmail": "9704793638@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ed31274154061b54c6c",
        "userId": 414,
        "userType": "Customer",
        "userName": "no name",
        "authMode": null,
        "userMobileNo": "9391388842",
        "userEmail": "9391388842@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ed8a411de445963e674",
        "userId": 415,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8712338935",
        "userEmail": "8712338935@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ef7a411de445963e679",
        "userId": 416,
        "userType": "Customer",
        "userName": "no name",
        "authMode": null,
        "userMobileNo": "9573024823",
        "userEmail": "9573024823@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f171274154061b54c71",
        "userId": 417,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9391224024",
        "userEmail": "9391224024@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f1b1274154061b54c7e",
        "userId": 418,
        "userType": "Customer",
        "userName": "no name",
        "authMode": null,
        "userMobileNo": "8309019777",
        "userEmail": "8309019777@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f2f1274154061b54c89",
        "userId": 419,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8897362020",
        "userEmail": "8897362020@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f3c1274154061b54c8f",
        "userId": 420,
        "userType": "Customer",
        "userName": "no name",
        "authMode": null,
        "userMobileNo": "8919098276",
        "userEmail": "8919098276@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f4a1274154061b54c93",
        "userId": 421,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9398125699",
        "userEmail": "9398125699@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541f9a1274154061b54cac",
        "userId": 422,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "7893077318",
        "userEmail": "7893077318@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541fbc1274154061b54cb1",
        "userId": 423,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "8767465937",
        "userEmail": "8767465937@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67541ff21274154061b54cb6",
        "userId": 424,
        "userType": "Customer",
        "userName": "Ram Kumar ",
        "authMode": null,
        "userMobileNo": "9640420012",
        "userEmail": "9640420012",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67542141a411de445963e6c7",
        "userId": 425,
        "userType": "Customer",
        "userName": "Sai Ganesh",
        "authMode": null,
        "userMobileNo": "8639754483",
        "userEmail": "8639754483",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67542d341274154061b54db2",
        "userId": 426,
        "userType": "Customer",
        "userName": "Sai Ram ",
        "authMode": null,
        "userMobileNo": "8179978273",
        "userEmail": "8179978273",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67542fd21274154061b54dee",
        "userId": 427,
        "userType": "NWSupport",
        "userName": "V.Harathi",
        "authMode": 1,
        "userMobileNo": "7093052434",
        "userEmail": "7093052434",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 285,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67543501a411de445963e804",
        "userId": 428,
        "userType": "Customer",
        "userName": "sameer",
        "authMode": null,
        "userMobileNo": "9502768515",
        "userEmail": "Vajeedmiya@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675438171274154061b54eaf",
        "userId": 429,
        "userType": "Customer",
        "userName": "hemantha",
        "authMode": null,
        "userMobileNo": "9177417513",
        "userEmail": "9177417513@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675438cca411de445963e82e",
        "userId": 430,
        "userType": "Customer",
        "userName": "promad",
        "authMode": null,
        "userMobileNo": "9542188286",
        "userEmail": "9542188286@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6755421a1274154061b550cd",
        "userId": 432,
        "userType": "Customer",
        "userName": "Alli",
        "authMode": null,
        "userMobileNo": "9391071621",
        "userEmail": "9391071621@GMAIL.COM",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6755a8e9a411de445963ecba",
        "userId": 433,
        "userType": "Customer",
        "userName": "krishna",
        "authMode": null,
        "userMobileNo": "9849068995",
        "userEmail": "9849068995@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6755a92ba411de445963ecbe",
        "userId": 434,
        "userType": "Customer",
        "userName": "manoj",
        "authMode": null,
        "userMobileNo": "8712340983",
        "userEmail": "8712340983@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67567c0aa411de445963ee27",
        "userId": 435,
        "userType": "Customer",
        "userName": "Aswin Kumar",
        "authMode": null,
        "userMobileNo": "9959962839",
        "userEmail": "aswind442@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675695f11274154061b554df",
        "userId": 436,
        "userType": "Customer",
        "userName": "RAKESH",
        "authMode": null,
        "userMobileNo": "9014414161",
        "userEmail": "9014414161@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67569913a411de445963ef76",
        "userId": 437,
        "userType": "Customer",
        "userName": "Vidhyasagar",
        "authMode": null,
        "userMobileNo": "9502330690",
        "userEmail": "9502330690",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67569940a411de445963ef8c",
        "userId": 438,
        "userType": "Customer",
        "userName": "Ali",
        "authMode": null,
        "userMobileNo": "6305680724",
        "userEmail": "6305680724",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756b952a411de445963f1bd",
        "userId": 439,
        "userType": "Customer",
        "userName": "Uma",
        "authMode": null,
        "userMobileNo": "6302801479",
        "userEmail": "6302801479",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756b987a411de445963f1c2",
        "userId": 440,
        "userType": "Customer",
        "userName": "SRIKANTH ",
        "authMode": null,
        "userMobileNo": "8374414007",
        "userEmail": "SRIKANTH",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756bae71274154061b55801",
        "userId": 441,
        "userType": "Customer",
        "userName": "Sk Riyaz",
        "authMode": null,
        "userMobileNo": "9652440367",
        "userEmail": "9652440367@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756c5b9a411de445963f312",
        "userId": 442,
        "userType": "Customer",
        "userName": "RAM",
        "authMode": null,
        "userMobileNo": "6304028572",
        "userEmail": "6304028572",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756d251a411de445963f3d5",
        "userId": 443,
        "userType": "Customer",
        "userName": "Giri",
        "authMode": null,
        "userMobileNo": "9397022630",
        "userEmail": "9397022630",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756d60dc3c5500c551e26c8",
        "userId": 444,
        "userType": "Customer",
        "userName": "Uma",
        "authMode": null,
        "userMobileNo": "9491771234",
        "userEmail": "9491771234@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756d737c3c5500c551e26e8",
        "userId": 445,
        "userType": "Customer",
        "userName": "Rajitha",
        "authMode": null,
        "userMobileNo": "9502381210",
        "userEmail": "9502381210",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756d7a9a411de445963f42a",
        "userId": 446,
        "userType": "Customer",
        "userName": "Nani",
        "authMode": null,
        "userMobileNo": "7013696259",
        "userEmail": "7013696259",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756db96a411de445963f46a",
        "userId": 447,
        "userType": "Customer",
        "userName": "Manikanta",
        "authMode": null,
        "userMobileNo": "9138050569",
        "userEmail": "9138050569@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756dc8fa411de445963f470",
        "userId": 448,
        "userType": "Customer",
        "userName": "K.SRINIVAS RAO ",
        "authMode": null,
        "userMobileNo": "9866545582",
        "userEmail": "9866545582",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756dce7a411de445963f474",
        "userId": 449,
        "userType": "Customer",
        "userName": "LAKSHMI ",
        "authMode": null,
        "userMobileNo": "9866110179",
        "userEmail": "LAKSHMI",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756dff2a411de445963f4bb",
        "userId": 450,
        "userType": "Customer",
        "userName": "BV.Koteshwar Rao",
        "authMode": null,
        "userMobileNo": "7997216666",
        "userEmail": "7997216666",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756e350c3c5500c551e283d",
        "userId": 451,
        "userType": "Customer",
        "userName": "Vijay",
        "authMode": null,
        "userMobileNo": "9959139433",
        "userEmail": "9959139433",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756e95fc3c5500c551e28af",
        "userId": 452,
        "userType": "Customer",
        "userName": "Ravi Prasad",
        "authMode": null,
        "userMobileNo": "9676587788",
        "userEmail": "9676587788",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756e9a0a411de445963f556",
        "userId": 453,
        "userType": "Customer",
        "userName": "Vamsikrishna RAAVI",
        "authMode": null,
        "userMobileNo": "9573586839",
        "userEmail": "9573586839",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756e9d1a411de445963f55a",
        "userId": 454,
        "userType": "Customer",
        "userName": "Sridhar Reddy",
        "authMode": null,
        "userMobileNo": "9885447934",
        "userEmail": "9885447934",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756ea04c3c5500c551e28b3",
        "userId": 455,
        "userType": "Customer",
        "userName": "Vishnu Singh",
        "authMode": null,
        "userMobileNo": "8686318342",
        "userEmail": "8686318342",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756ea3ac3c5500c551e28b7",
        "userId": 456,
        "userType": "Customer",
        "userName": "Suvarna K",
        "authMode": null,
        "userMobileNo": "9440453640",
        "userEmail": "9440453640",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756ea5aa411de445963f55f",
        "userId": 457,
        "userType": "Customer",
        "userName": "Ravi Siva Nageshwar Rao",
        "authMode": null,
        "userMobileNo": "9346196757",
        "userEmail": "9346196757",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756ebbac3c5500c551e28bc",
        "userId": 458,
        "userType": "Customer",
        "userName": "",
        "authMode": null,
        "userMobileNo": "9553366436",
        "userEmail": "9553366436",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756ebfac3c5500c551e28c0",
        "userId": 459,
        "userType": "Customer",
        "userName": "Krishang",
        "authMode": null,
        "userMobileNo": "9441130070",
        "userEmail": "9441130070",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756f0c7c3c5500c551e28d3",
        "userId": 460,
        "userType": "Customer",
        "userName": "Rajesh Kumar",
        "authMode": null,
        "userMobileNo": "8885647419",
        "userEmail": "8885647419",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756f142a411de445963f57d",
        "userId": 461,
        "userType": "Customer",
        "userName": "Rama Krishna",
        "authMode": null,
        "userMobileNo": "9441077113",
        "userEmail": "9441077113",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756f16aa411de445963f581",
        "userId": 462,
        "userType": "Customer",
        "userName": "Karuna Kumar",
        "authMode": null,
        "userMobileNo": "9666657360",
        "userEmail": "9666657360",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6756f1ecc3c5500c551e28d9",
        "userId": 463,
        "userType": "Customer",
        "userName": "T Venkatesh Karthik ",
        "authMode": null,
        "userMobileNo": "9553541321",
        "userEmail": "tvk1018@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757c445039bd226f0d0a12e",
        "userId": 464,
        "userType": "Customer",
        "userName": "Salmanraju",
        "authMode": null,
        "userMobileNo": "7989234031",
        "userEmail": "Salmanraju",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757ccd2039bd226f0d0a185",
        "userId": 465,
        "userType": "Customer",
        "userName": "GENARAM SEERVI ",
        "authMode": null,
        "userMobileNo": "8341437964",
        "userEmail": "8341437964@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757dbf0039bd226f0d0a1cc",
        "userId": 466,
        "userType": "Customer",
        "userName": "Sai Goud",
        "authMode": null,
        "userMobileNo": "8121821999",
        "userEmail": "8121821999",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757de1f039bd226f0d0a1e4",
        "userId": 467,
        "userType": "Customer",
        "userName": "M.shafiuddin",
        "authMode": null,
        "userMobileNo": "9959636501",
        "userEmail": "M.shafiuddin",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757e32da411de445963f7d0",
        "userId": 468,
        "userType": "Customer",
        "userName": "Satyam Babu",
        "authMode": null,
        "userMobileNo": "9441429023",
        "userEmail": "9441429023",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757e345a411de445963f7d4",
        "userId": 469,
        "userType": "Customer",
        "userName": "Abdul",
        "authMode": null,
        "userMobileNo": "9502346324",
        "userEmail": "9502346324",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757e398a411de445963f7da",
        "userId": 470,
        "userType": "Customer",
        "userName": "kareem kareem",
        "authMode": null,
        "userMobileNo": "9700661603",
        "userEmail": "9700661603",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757e70c039bd226f0d0a274",
        "userId": 471,
        "userType": "Customer",
        "userName": "Eshwar S",
        "authMode": null,
        "userMobileNo": "9666797628",
        "userEmail": "9666797628@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757ea51039bd226f0d0a2c3",
        "userId": 472,
        "userType": "Customer",
        "userName": "Meenakshi achary Vellanki",
        "authMode": null,
        "userMobileNo": "8332955016",
        "userEmail": "8332955016@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757f024a411de445963f92a",
        "userId": 473,
        "userType": "Customer",
        "userName": "Satya Narayana ",
        "authMode": null,
        "userMobileNo": "9640848585",
        "userEmail": "9640848585",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6757fee5039bd226f0d0a396",
        "userId": 474,
        "userType": "Customer",
        "userName": "Srinu ",
        "authMode": null,
        "userMobileNo": "9959741668",
        "userEmail": "9959741668@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675803a7039bd226f0d0a4b4",
        "userId": 475,
        "userType": "Customer",
        "userName": "kalyani",
        "authMode": null,
        "userMobileNo": "9392260190",
        "userEmail": "9392260190@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675807120f7e3b38de97929a",
        "userId": 476,
        "userType": "Customer",
        "userName": "M.LAKSHMAIAH",
        "authMode": null,
        "userMobileNo": "9951147666",
        "userEmail": "9951147666@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6758076c039bd226f0d0a4e2",
        "userId": 477,
        "userType": "Customer",
        "userName": "RATNABABU ",
        "authMode": null,
        "userMobileNo": "8328579771",
        "userEmail": "RATNABABU",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67580774039bd226f0d0a4e6",
        "userId": 478,
        "userType": "Customer",
        "userName": "Srinivas goud puntikura",
        "authMode": null,
        "userMobileNo": "9000660846",
        "userEmail": "9000660846",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675807c20f7e3b38de9792a4",
        "userId": 479,
        "userType": "Customer",
        "userName": " Abhi",
        "authMode": null,
        "userMobileNo": "9494422539",
        "userEmail": "abhikevin123@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6758090e0f7e3b38de9792bf",
        "userId": 480,
        "userType": "Customer",
        "userName": "Dany",
        "authMode": null,
        "userMobileNo": "8374298715",
        "userEmail": "8374298715",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67580987039bd226f0d0a52f",
        "userId": 481,
        "userType": "Customer",
        "userName": "Sai krishna",
        "authMode": null,
        "userMobileNo": "9014929443",
        "userEmail": "9014929443",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675809b90f7e3b38de9792fb",
        "userId": 482,
        "userType": "Customer",
        "userName": "Kishor sharma",
        "authMode": null,
        "userMobileNo": "9701939351",
        "userEmail": "9701939351",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675809d50f7e3b38de9792ff",
        "userId": 483,
        "userType": "Customer",
        "userName": "Sri sri",
        "authMode": null,
        "userMobileNo": "8919294934",
        "userEmail": "8919294934",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67580a020f7e3b38de979307",
        "userId": 484,
        "userType": "Customer",
        "userName": "Hanumanthu Bhujendra",
        "authMode": null,
        "userMobileNo": "9703414011",
        "userEmail": "aksaybujji@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67580e230f7e3b38de979362",
        "userId": 485,
        "userType": "Customer",
        "userName": "Swathi",
        "authMode": null,
        "userMobileNo": "9948147756",
        "userEmail": "8639561543@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67583da00f7e3b38de97967c",
        "userId": 486,
        "userType": "Customer",
        "userName": "Vijay",
        "authMode": null,
        "userMobileNo": "8885848487",
        "userEmail": "8885848487",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590e9ddb819f20cbd69698",
        "userId": 487,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8143671889",
        "userEmail": "8143671889@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590eb80f7e3b38de979843",
        "userId": 488,
        "userType": "Customer",
        "userName": "Kali",
        "authMode": null,
        "userMobileNo": "8919253511",
        "userEmail": "8919253511@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590edadb819f20cbd6969c",
        "userId": 489,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7799259777",
        "userEmail": "7799259777@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590eeedb819f20cbd696a0",
        "userId": 490,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9908312468",
        "userEmail": "9908312468@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590f0a0f7e3b38de979847",
        "userId": 491,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7794937654",
        "userEmail": "7794937654@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590f2fdb819f20cbd696b4",
        "userId": 492,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8790151780",
        "userEmail": "8790151780@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590f46db819f20cbd696b8",
        "userId": 493,
        "userType": "Customer",
        "userName": "Kali",
        "authMode": null,
        "userMobileNo": "8008698411",
        "userEmail": "8008698411@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590f61db819f20cbd696bd",
        "userId": 494,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8331866255",
        "userEmail": "8331866255@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590f7a0f7e3b38de97985b",
        "userId": 495,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7815874502",
        "userEmail": "7815874502@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590fa8db819f20cbd696c1",
        "userId": 496,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "6305849960",
        "userEmail": "6305849960@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590fc2db819f20cbd696c5",
        "userId": 497,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "6302987034",
        "userEmail": "6302987034@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590fdb0f7e3b38de979871",
        "userId": 498,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9908631920",
        "userEmail": "9908631920@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67590ff3db819f20cbd696c9",
        "userId": 499,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8977770458",
        "userEmail": "8977770458@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759101f0f7e3b38de979875",
        "userId": 500,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9989674921",
        "userEmail": "9989674921@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675910330f7e3b38de979879",
        "userId": 501,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8008837127",
        "userEmail": "8008837127@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759104a0f7e3b38de97987d",
        "userId": 502,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9849605199",
        "userEmail": "9849605199@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67591070db819f20cbd696ce",
        "userId": 503,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8465959476",
        "userEmail": "8465959476@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675910a90f7e3b38de979881",
        "userId": 504,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8688423972",
        "userEmail": "8688423972@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675910c90f7e3b38de979885",
        "userId": 505,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7731977679",
        "userEmail": "7731977679@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67591125db819f20cbd696d2",
        "userId": 506,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9347231920",
        "userEmail": "9347231920@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759114a0f7e3b38de97988a",
        "userId": 507,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8121405832",
        "userEmail": "8121405832@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675911c50f7e3b38de97988e",
        "userId": 508,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8019139974",
        "userEmail": "8019139974@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759121f0f7e3b38de979893",
        "userId": 509,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9381953813",
        "userEmail": "9381953813@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675912370f7e3b38de97989c",
        "userId": 510,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "8712134689",
        "userEmail": "8712134689@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675912590f7e3b38de9798a0",
        "userId": 511,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9393067076",
        "userEmail": "9393067076@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675928f00f7e3b38de979916",
        "userId": 512,
        "userType": "Customer",
        "userName": "Pavan Kumar Tadiboina",
        "authMode": null,
        "userMobileNo": "8247344479",
        "userEmail": "8247344479@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594236e03e8b04d7984bce",
        "userId": 513,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7396384821",
        "userEmail": "7396384821@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594255525238681eeb46b8",
        "userId": 514,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9346056743",
        "userEmail": "9346056743@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759426d525238681eeb46bc",
        "userId": 515,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "9959501819",
        "userEmail": "9959501819@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594285525238681eeb46c0",
        "userId": 516,
        "userType": "Customer",
        "userName": "kali",
        "authMode": null,
        "userMobileNo": "7337362747",
        "userEmail": "7337362747@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594331525238681eeb46c5",
        "userId": 517,
        "userType": "Customer",
        "userName": "Naresh",
        "authMode": null,
        "userMobileNo": "8688584061",
        "userEmail": "8688584061",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759433d525238681eeb46c9",
        "userId": 518,
        "userType": "Customer",
        "userName": "hema",
        "authMode": null,
        "userMobileNo": "8328636559",
        "userEmail": "8328636559@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594347525238681eeb46cd",
        "userId": 519,
        "userType": "Customer",
        "userName": "Jaya sree",
        "authMode": null,
        "userMobileNo": "8790728401",
        "userEmail": "8790728401",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759437f525238681eeb46d1",
        "userId": 520,
        "userType": "Customer",
        "userName": "srinuvas",
        "authMode": null,
        "userMobileNo": "9704804999",
        "userEmail": "9704804999@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675943a0e03e8b04d7984bd6",
        "userId": 521,
        "userType": "Customer",
        "userName": "pavan sai",
        "authMode": null,
        "userMobileNo": "7207291635",
        "userEmail": "7207291635@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594e4de03e8b04d7984bff",
        "userId": 522,
        "userType": "Customer",
        "userName": "Ramesh babu",
        "authMode": null,
        "userMobileNo": "9618342194",
        "userEmail": "9618342194",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594e9de03e8b04d7984c04",
        "userId": 523,
        "userType": "Customer",
        "userName": "Abhi",
        "authMode": null,
        "userMobileNo": "8978963117",
        "userEmail": "8978963117",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594f78525238681eeb4716",
        "userId": 524,
        "userType": "Customer",
        "userName": "Malesh",
        "authMode": null,
        "userMobileNo": "9030720666",
        "userEmail": "9030720666",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67594f94e03e8b04d7984c09",
        "userId": 525,
        "userType": "Customer",
        "userName": "Ajay",
        "authMode": null,
        "userMobileNo": "8374987981",
        "userEmail": "9030720666",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67595fcae03e8b04d7984d68",
        "userId": 526,
        "userType": "Customer",
        "userName": "Epuri",
        "authMode": null,
        "userMobileNo": "9849355719",
        "userEmail": "9849355719@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759675e694d793413586aac",
        "userId": 527,
        "userType": "Customer",
        "userName": "Vasuri Chandra prasad",
        "authMode": null,
        "userMobileNo": "6303548517",
        "userEmail": "6303548517",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67596876e03e8b04d7984dc4",
        "userId": 528,
        "userType": "Customer",
        "userName": "yogisaara reddy",
        "authMode": null,
        "userMobileNo": "7416660754",
        "userEmail": "7416660754",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675968a8694d793413586ab0",
        "userId": 529,
        "userType": "Customer",
        "userName": "Satiresddy",
        "authMode": null,
        "userMobileNo": "8977884888",
        "userEmail": "8977884888",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675968dce03e8b04d7984dc8",
        "userId": 530,
        "userType": "Customer",
        "userName": "GANESH ",
        "authMode": null,
        "userMobileNo": "8919529991",
        "userEmail": "8919529991",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67596911694d793413586ab4",
        "userId": 531,
        "userType": "Customer",
        "userName": "VAMSI KRISHNA",
        "authMode": null,
        "userMobileNo": "9652507595",
        "userEmail": "9652507595",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759693a694d793413586ab8",
        "userId": 532,
        "userType": "Customer",
        "userName": "M.Ashok",
        "authMode": null,
        "userMobileNo": "9866998499",
        "userEmail": "9866998499",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759696a694d793413586abc",
        "userId": 533,
        "userType": "Customer",
        "userName": "Fasiyoddin",
        "authMode": null,
        "userMobileNo": "8801163111",
        "userEmail": "8801163111",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675969aee03e8b04d7984dcc",
        "userId": 534,
        "userType": "Customer",
        "userName": "Navakumar",
        "authMode": null,
        "userMobileNo": "8106588032",
        "userEmail": "8106588032",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675969cde03e8b04d7984dd0",
        "userId": 535,
        "userType": "Customer",
        "userName": "Lakshmi",
        "authMode": null,
        "userMobileNo": "9866403420",
        "userEmail": "9866403420",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67596a25e03e8b04d7984dd4",
        "userId": 536,
        "userType": "Customer",
        "userName": "Nagesh",
        "authMode": null,
        "userMobileNo": "9666002300",
        "userEmail": "9666002300",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67596a54694d793413586ac0",
        "userId": 537,
        "userType": "Customer",
        "userName": "Bhimeshwar",
        "authMode": null,
        "userMobileNo": "8885558712",
        "userEmail": "8885558712",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67597cff694d793413586b9e",
        "userId": 538,
        "userType": "Customer",
        "userName": "satyanarayana",
        "authMode": null,
        "userMobileNo": "9573242961",
        "userEmail": "9573242961@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67598630728de035ed45784e",
        "userId": 539,
        "userType": "Customer",
        "userName": "dheeraj",
        "authMode": null,
        "userMobileNo": "8099911119",
        "userEmail": "dheeraj",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6759a9b4694d793413586dc5",
        "userId": 540,
        "userType": "Customer",
        "userName": "prasanth",
        "authMode": null,
        "userMobileNo": "8688106321",
        "userEmail": "8688106321@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675a5beb728de035ed457a19",
        "userId": 541,
        "userType": "Customer",
        "userName": "Sai",
        "authMode": null,
        "userMobileNo": "9347365702",
        "userEmail": "9347365702@gamil.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675a5d09728de035ed457a3d",
        "userId": 542,
        "userType": "Customer",
        "userName": "Sharath",
        "authMode": null,
        "userMobileNo": "8008551268",
        "userEmail": "8008551268",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675a6059bde2a54f35a18cdb",
        "userId": 543,
        "userType": "Customer",
        "userName": "VENKAT REDDY ",
        "authMode": null,
        "userMobileNo": "9700454645",
        "userEmail": "VENKAT REDDY",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675a8016f000fb33044d82c2",
        "userId": 544,
        "userType": "Customer",
        "userName": "sai",
        "authMode": null,
        "userMobileNo": "9676795279",
        "userEmail": "9676795279@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675a899abb143608d420e272",
        "userId": 545,
        "userType": "Customer",
        "userName": "P.SIVA KUMAR",
        "authMode": null,
        "userMobileNo": "7815802800",
        "userEmail": "7815802800",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675aba894c20907f6da23e3d",
        "userId": 546,
        "userType": "Customer",
        "userName": "nani",
        "authMode": null,
        "userMobileNo": "9063297960",
        "userEmail": "9063297960@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675abea34c20907f6da23e57",
        "userId": 547,
        "userType": "Customer",
        "userName": "Jayram",
        "authMode": null,
        "userMobileNo": "9542482072",
        "userEmail": "9542482072",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675abed64c20907f6da23e5b",
        "userId": 548,
        "userType": "Customer",
        "userName": "Arihant Jain",
        "authMode": null,
        "userMobileNo": "8688276036",
        "userEmail": "8688276036",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac5b9437ddc224f3008a1",
        "userId": 549,
        "userType": "Customer",
        "userName": "Pranav Sanghadia",
        "authMode": null,
        "userMobileNo": "9032333110",
        "userEmail": "9032333110",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac5da4c20907f6da23e7d",
        "userId": 550,
        "userType": "Customer",
        "userName": "Riken Morakhiya",
        "authMode": null,
        "userMobileNo": "9323110246",
        "userEmail": "9323110246",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac604437ddc224f3008a5",
        "userId": 551,
        "userType": "Customer",
        "userName": "Naga Suresh sharam",
        "authMode": null,
        "userMobileNo": "8096415423",
        "userEmail": "8096415423",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac6244c20907f6da23e85",
        "userId": 552,
        "userType": "Customer",
        "userName": "Ashok Irla",
        "authMode": null,
        "userMobileNo": "9100771078",
        "userEmail": "9100771078",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac645437ddc224f3008ab",
        "userId": 553,
        "userType": "Customer",
        "userName": "020115_Sree Communication4",
        "authMode": null,
        "userMobileNo": "9346396699",
        "userEmail": "9346396699",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac65e4c20907f6da23e89",
        "userId": 554,
        "userType": "Customer",
        "userName": "Lakshmi",
        "authMode": null,
        "userMobileNo": "9550441490",
        "userEmail": "9550441490",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac675437ddc224f3008af",
        "userId": 555,
        "userType": "Customer",
        "userName": "Paresh Sanghadia",
        "authMode": null,
        "userMobileNo": "9347211682",
        "userEmail": "9347211682",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac6b0437ddc224f3008b7",
        "userId": 557,
        "userType": "Customer",
        "userName": "Sri sailam Boini",
        "authMode": null,
        "userMobileNo": "9848724154",
        "userEmail": "9848724154",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac6ce437ddc224f3008bb",
        "userId": 558,
        "userType": "Customer",
        "userName": "Ganesh varma",
        "authMode": null,
        "userMobileNo": "9849217706",
        "userEmail": "9849217706",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac6e9437ddc224f3008bf",
        "userId": 559,
        "userType": "Customer",
        "userName": "Suryadevara Venkata Ramana",
        "authMode": null,
        "userMobileNo": "8919363890",
        "userEmail": "8919363890",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7014c20907f6da23e8d",
        "userId": 560,
        "userType": "Customer",
        "userName": "Mahesh srjurnalist",
        "authMode": null,
        "userMobileNo": "9848450058",
        "userEmail": "9848450058",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac71f437ddc224f3008c3",
        "userId": 561,
        "userType": "Customer",
        "userName": "Gollamudi Sathish",
        "authMode": null,
        "userMobileNo": "9948820404",
        "userEmail": "9948820404",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7394c20907f6da23e91",
        "userId": 562,
        "userType": "Customer",
        "userName": "S Prasad",
        "authMode": null,
        "userMobileNo": "7013376225",
        "userEmail": "7013376225",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac75c437ddc224f3008c7",
        "userId": 563,
        "userType": "Customer",
        "userName": "Media M",
        "authMode": null,
        "userMobileNo": "7386891234",
        "userEmail": "7386891234",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7744c20907f6da23e95",
        "userId": 564,
        "userType": "Customer",
        "userName": "Muddana Ravi",
        "authMode": null,
        "userMobileNo": "9885439585",
        "userEmail": "9885439585",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7a1437ddc224f3008cb",
        "userId": 565,
        "userType": "Customer",
        "userName": "Npragada ",
        "authMode": null,
        "userMobileNo": "7989633679",
        "userEmail": "7989633679",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7be4c20907f6da23e99",
        "userId": 566,
        "userType": "Customer",
        "userName": "R V Prasad",
        "authMode": null,
        "userMobileNo": "7287001234",
        "userEmail": "7287001234",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac7ec437ddc224f3008cf",
        "userId": 567,
        "userType": "Customer",
        "userName": "Shiva naga prasad",
        "authMode": null,
        "userMobileNo": "9885695446",
        "userEmail": "9885695446",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac8074c20907f6da23ea1",
        "userId": 568,
        "userType": "Customer",
        "userName": "N RAVI",
        "authMode": null,
        "userMobileNo": "9866807364",
        "userEmail": "9866807364",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ac825437ddc224f3008d3",
        "userId": 569,
        "userType": "Customer",
        "userName": "Botte Saharsh",
        "authMode": null,
        "userMobileNo": "9398478484",
        "userEmail": "9398478484",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675bc686f9fdae343e719890",
        "userId": 570,
        "userType": "Customer",
        "userName": "Anil ",
        "authMode": null,
        "userMobileNo": "6300297880",
        "userEmail": "6300297880",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675bd2b78aa27750d824203c",
        "userId": 571,
        "userType": "Customer",
        "userName": "P.Sumanth",
        "authMode": null,
        "userMobileNo": "9347086067",
        "userEmail": "9347086067@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675bd530f9fdae343e7198df",
        "userId": 572,
        "userType": "Customer",
        "userName": "Ashok",
        "authMode": null,
        "userMobileNo": "6304354315",
        "userEmail": "6304354315@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675bd84ff9fdae343e719901",
        "userId": 573,
        "userType": "Customer",
        "userName": "Sudheer",
        "authMode": null,
        "userMobileNo": "7989706662",
        "userEmail": "7989706662",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675c0d9456843f014c73f9cb",
        "userId": 574,
        "userType": "Customer",
        "userName": "Rashmi",
        "authMode": null,
        "userMobileNo": "9491262992",
        "userEmail": "9491262992",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675c0ec056843f014c73f9d0",
        "userId": 575,
        "userType": "Customer",
        "userName": "Ajay",
        "authMode": null,
        "userMobileNo": "7995642384",
        "userEmail": "7995642384",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675d044256843f014c73fc37",
        "userId": 576,
        "userType": "Customer",
        "userName": "Rajesh",
        "authMode": null,
        "userMobileNo": "8500550060",
        "userEmail": "8500550060@GMAIL.COM",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675d1c47b2826639fbf8c02c",
        "userId": 577,
        "userType": "Customer",
        "userName": "Thirumalesh",
        "authMode": null,
        "userMobileNo": "9324914574",
        "userEmail": "9324914574@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675d616bb2826639fbf8c344",
        "userId": 578,
        "userType": "Customer",
        "userName": "Vamsi",
        "authMode": null,
        "userMobileNo": "7799946161",
        "userEmail": "7799946161",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ea358b2826639fbf8c635",
        "userId": 579,
        "userType": "Customer",
        "userName": "Srikanth",
        "authMode": null,
        "userMobileNo": "9652470509",
        "userEmail": "9652470509",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ea66256843f014c74030d",
        "userId": 580,
        "userType": "Customer",
        "userName": "Jagadesh",
        "authMode": null,
        "userMobileNo": "9666238414",
        "userEmail": "9666238414",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ebd8456843f014c740383",
        "userId": 581,
        "userType": "Customer",
        "userName": "Prasanth",
        "authMode": null,
        "userMobileNo": "8074463777",
        "userEmail": "8074463777",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "675ec7f6b2826639fbf8c6b0",
        "userId": 582,
        "userType": "Customer",
        "userName": "Askok",
        "authMode": null,
        "userMobileNo": "9849368550",
        "userEmail": "9849368550",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67612dee83b7e744fe3d7267",
        "userId": 583,
        "userType": "Customer",
        "userName": "Zakir",
        "authMode": null,
        "userMobileNo": "9676140125",
        "userEmail": "9676140125@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "676148f583b7e744fe3d7285",
        "userId": 584,
        "userType": "Customer",
        "userName": "Sameer",
        "authMode": null,
        "userMobileNo": "6305122747",
        "userEmail": "6305122747",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "676501c10a6a57382a4a8aa0",
        "userId": 585,
        "userType": "Customer",
        "userName": "Vishalini",
        "authMode": null,
        "userMobileNo": "8099911511",
        "userEmail": "8099911511",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67669e58a366277d9a70ece5",
        "userId": 586,
        "userType": "Customer",
        "userName": "Tejaswini",
        "authMode": null,
        "userMobileNo": "9701013582",
        "userEmail": "9701013582@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "676ab231a366277d9a70f073",
        "userId": 587,
        "userType": "Customer",
        "userName": "chadrashaker ",
        "authMode": null,
        "userMobileNo": "9701932833",
        "userEmail": "9701932833@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "6799c0f3bdd6b01370308848",
        "userId": 588,
        "userType": "Technician",
        "userName": "Satyanarayana",
        "authMode": 1,
        "userMobileNo": "8886665515",
        "userEmail": "satyanarayanrvrmail@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [
            7
        ],
        "roleName": [
            "AdminC"
        ],
        "reportsTo": 285,
        "rolePrevilages": [
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 4,
                "groupName": "Master Data Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ticket-types",
                        "description": "Define Ticket Types",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketType"
                            },
                            {
                                "controllerName": "ticket-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "ticket-sub-types",
                        "description": "Define Ticket SubTypes",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticketSubType"
                            },
                            {
                                "controllerName": "ticket-sub-type-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticketSubType/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 11,
                        "name": "task-master",
                        "description": "Task Master",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-master-controlller",
                                "type": "POST",
                                "serverPrivilege": "/taskMaster"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controlller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 15,
                "groupName": "Network Visibility",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "network-design",
                        "description": "Network Design",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "object-template",
                        "description": "Device Template",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "object-type",
                        "description": "Object Type",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "object-group",
                        "description": "Object Group",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "layer-object",
                        "description": "View Network",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "route-map",
                        "description": "Route Map",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 1,
                "groupName": "Task Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "tasklist",
                        "description": "List of Tasks",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/task/hardDelete/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{searchKey}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllNonActiveTask/{cid}/{pageNo}/{recordsPerPage}"
                            },
                            {
                                "controllerName": "upload-files",
                                "type": "POST",
                                "serverPrivilege": "/upload-file/uploadFile"
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "my-tasks",
                        "description": "My Tasks",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByAssignedToBetweenDates/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getUserNonActiveTask/{cid}/{assignedToId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "taskPostedByMe",
                        "description": "Task Posted By Me",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/getAllByCreatedBy/{cid}/{userId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "POST",
                                "serverPrivilege": "/task/assignToUser"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "PUT",
                                "serverPrivilege": "/task/updateTaskStatus/{taskId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByStatus/{cid}/{status}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/all/{cid}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "task-controller",
                                "type": "GET",
                                "serverPrivilege": "/task/filterByWildSearch/{cid}/{searchKey}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "all-task-status-wise",
                        "description": "Task Status Wise",
                        "add": false,
                        "view": false,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 2,
                "groupName": "Ticket Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 5,
                        "name": "ticketPostedByMe",
                        "description": "Ticket Posted By Me",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{cid}/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketPostedByMe/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}/{status}"
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "ticketlist",
                        "description": "List of Tickets",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getAllTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/getTicketTaskByTicketId/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/all/{cid}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/ticket/hardDelete/{id}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/{id}"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insertConversation"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "PUT",
                                "serverPrivilege": "/ticket/updateTicketStatus/{ticketId}"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/assignToUser"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/all/{cid}"
                            },
                            {
                                "controllerName": "task-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/taskMaster/getAllTaskNameAndDescription"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "POST",
                                "serverPrivilege": "/ticket/insertTicketTask"
                            },
                            {
                                "controllerName": "ticket-controller",
                                "type": "GET",
                                "serverPrivilege": "/ticket/filterByStatus/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "ticket-prioritytime-list",
                        "description": "Ticket Priority Time List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 5,
                "groupName": "Prospect Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "prospect",
                        "description": "List of Prospects",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "approval",
                        "description": "Tobe Approved List",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/all/{cid}"
                            },
                            {
                                "controllerName": "prospect-registration-controller",
                                "type": "GET",
                                "serverPrivilege": "/prospectRegistration/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 9,
                "groupName": "Customer Info Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "customer-info",
                        "description": "Customer Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInfo"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/{id}"
                            },
                            {
                                "controllerName": "customer-param-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerParam/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 5,
                        "name": "customer-location-info",
                        "description": "Customer Location Info",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInfo/getAllCustomerResponse/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 6,
                        "name": "customer-invoice",
                        "description": "Customer Invoice",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerInvoice"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/{id}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "customer-payments",
                        "description": "Customer Payments",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerPayment"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/{id}"
                            },
                            {
                                "controllerName": "customer-payment-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerPayment/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/all/{cid}"
                            },
                            {
                                "controllerName": "customer-invoice-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerInvoice/getRespponseByInvoiceNo/{invoiceNo}"
                            }
                        ]
                    },
                    {
                        "seqNo": 8,
                        "name": "customer-plan",
                        "description": "Customer plan",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo/addCustomerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerplanInfo"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfogetUsedUnusedplanByEmailOrPhone/{emailOrPhone}"
                            },
                            {
                                "controllerName": "customer-plan-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerplanInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 9,
                        "name": "customer-usage",
                        "description": "Customer Usage",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "POST",
                                "serverPrivilege": "/customerNetUsageInfo"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/all/{cid}"
                            },
                            {
                                "controllerName": "customer-net-usage-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/customerNetUsageInfo/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "User Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "users-list",
                        "description": "List of Users",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "POST",
                                "serverPrivilege": "/userParameter"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/insert"
                            },
                            {
                                "controllerName": "users-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "user-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/userParameter/getByUserId/{id}"
                            },
                            {
                                "controllerName": "predefined-parameter-controller",
                                "type": "GET",
                                "serverPrivilege": "/predefinedParameter/all"
                            },
                            {
                                "controllerName": "roles-controller",
                                "type": "GET",
                                "serverPrivilege": "/roles/all{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "change-password",
                        "description": "change password",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "users-controller",
                                "type": "POST",
                                "serverPrivilege": "/users/resetPassword"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "employee-hierarchy",
                        "description": "User Hierarchy",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 16,
                "groupName": "Employee Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "employee-attendence",
                        "description": "Employee Attendence",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByDate/{cid}/{date}"
                            },
                            {
                                "controllerName": "user-attendance-controller",
                                "type": "GET",
                                "serverPrivilege": "/userAttendance/getByUserTdAndDate/{userId}/{date}"
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "user-tracking",
                        "description": "User Tracking",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "user-controller",
                                "type": "GET",
                                "serverPrivilege": "/users/all/{cid}"
                            },
                            {
                                "controllerName": "client-location-controller",
                                "type": "POST",
                                "serverPrivilege": "/clientLocation/getAllByCidAndUsernameAndBetweenDates"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "user-latest-tracking",
                        "description": "User Latest Tracking",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 3,
                "groupName": "Inventory Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "product",
                        "description": "Product List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/productMaster"
                            },
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "vendor-list",
                        "description": "Vendors List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 7,
                        "name": "branch",
                        "description": "Define Branch",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "branch-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/branchMaster"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{id}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "DELETE",
                                "serverPrivilege": "/branchMaster/hardDelete/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 10,
                        "name": "material-purchases",
                        "description": "Material Purchases",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialPurchase"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/all/{cid}"
                            },
                            {
                                "controllerName": "material-purchase-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialPurchase/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 12,
                        "name": "material-transfer",
                        "description": "Material Transfer",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialTransfer"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/all/{cid}"
                            },
                            {
                                "controllerName": "material-transfer-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialTransfer/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 14,
                        "name": "material-issues",
                        "description": "Material Issue",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-to-be-issued",
                        "description": "Material To Be Issued",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "material-issued-list",
                        "description": "Material Issued List",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "material-requests",
                        "description": "Material Issue-Requests",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "vendor-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/vendorMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "POST",
                                "serverPrivilege": "/materialIssue"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/all/{cid}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/{id}"
                            },
                            {
                                "controllerName": "material-issue-controller",
                                "type": "GET",
                                "serverPrivilege": "/materialIssue/getByLatestStatus/{latestStatus}"
                            }
                        ]
                    },
                    {
                        "seqNo": 16,
                        "name": "productstock",
                        "description": "Product Stock Info",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-stock-info-controller",
                                "type": "GET",
                                "serverPrivilege": "/productStockInfo/all/{cid}"
                            }
                        ]
                    },
                    {
                        "seqNo": 0,
                        "name": "latest-product-stock",
                        "description": "Product Stock",
                        "add": false,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 18,
                        "name": "product-opening-balance",
                        "description": "Product Opening Balance",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "product-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/productMaster/all/{cid}"
                            },
                            {
                                "controllerName": "branch-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/branchMaster/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "POST",
                                "serverPrivilege": "/productOpeningBalance"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/all/{cid}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/getById/{id}"
                            },
                            {
                                "controllerName": "product-opening-balance-controller",
                                "type": "GET",
                                "serverPrivilege": "/productOpeningBalance/approveOpeningBalance"
                            }
                        ]
                    },
                    {
                        "seqNo": 22,
                        "name": "uom",
                        "description": "Uom",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "uom-master-controller",
                                "type": "POST",
                                "serverPrivilege": "/uomMaster"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/al/{cid}"
                            },
                            {
                                "controllerName": "uom-master-controller",
                                "type": "GET",
                                "serverPrivilege": "/uomMaster/{id}"
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": true,
                "description": "string",
                "id": null,
                "screenGroupId": null,
                "seqNo": 36,
                "groupName": "Existing Customer Info",
                "screenPrivilegeList": [
                    {
                        "seqNo": 1,
                        "name": "ec-list",
                        "description": "Existing Customer List",
                        "add": true,
                        "view": true,
                        "modify": false,
                        "delete": false,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": 114118114100
            },
            {
                "createdDate": null,
                "createdBy": null,
                "createdByUserName": null,
                "auditList": null,
                "version": 0,
                "isActive": null,
                "description": null,
                "id": null,
                "screenGroupId": null,
                "seqNo": 10,
                "groupName": "Indent Module",
                "screenPrivilegeList": [
                    {
                        "seqNo": 0,
                        "name": "indent-info",
                        "description": "Indent Info",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 1,
                        "name": "indent-info-request",
                        "description": "Indent Requests",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 2,
                        "name": "indent-info-approve",
                        "description": "Approve Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 3,
                        "name": "indent-info-issue",
                        "description": "Issue Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    },
                    {
                        "seqNo": 4,
                        "name": "indent-info-verify",
                        "description": "Verify Indents",
                        "add": true,
                        "view": true,
                        "modify": true,
                        "delete": true,
                        "originalName": null,
                        "screenPrivilegeScopeList": [
                            {
                                "controllerName": "",
                                "type": "",
                                "serverPrivilege": ""
                            }
                        ]
                    }
                ],
                "cid": null
            }
        ],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "679e1731ac1ec66ceb6c4f05",
        "userId": 589,
        "userType": "Technician",
        "userName": "Jayanth",
        "authMode": 1,
        "userMobileNo": "7097311487",
        "userEmail": "jayanthgoud110@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": null,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "679e1760ac1ec66ceb6c4f06",
        "userId": 590,
        "userType": "Technician",
        "userName": "Adhitya",
        "authMode": 1,
        "userMobileNo": "7793990088",
        "userEmail": "arepalliadithya@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 592,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67b59669faed281c4cd07f91",
        "userId": 591,
        "userType": "Technician",
        "userName": "Dhasaradha",
        "authMode": 1,
        "userMobileNo": "7095052981",
        "userEmail": "chakalidasharatha05@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 592,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    },
    {
        "id": "67b5976be3250d1c7330896e",
        "userId": 592,
        "userType": "Technician",
        "userName": "Rakesh",
        "authMode": 1,
        "userMobileNo": "9705743251",
        "userEmail": "rakeshchary372@gmail.com",
        "imageURL": "",
        "token": null,
        "isVerified": true,
        "dashboardIds": null,
        "roleId": [],
        "roleName": [],
        "reportsTo": 0,
        "rolePrevilages": [],
        "userParams": null,
        "userParameters": null,
        "branchId": null,
        "cid": 114118114100
    }
]

  constructor(private generic_service: GenericService) { }


  users: any = []

  ngOnInit(): void {

    this.getUsers()

  }


  getUsers(){
    this.generic_service.getUsers().subscribe(
        (response: any)=>{
            console.log(response)
            this.users = this.report

            let usersList: any = [];

            console.log(this.users)
        
            for(let list of this.users){

              if(list.reportsTo == 0){
                console.log(list)
              }

              usersList.push(
                { id: list.userId, label: list.userName, report: list.reportsTo }
              )
            }
        
            console.log(usersList)
        
        
            const uniqueUsers = usersList.filter((user: any, index: any, self: any) =>
              index === self.findIndex((t: any) => t.id === user.id)
            );
        
            const generateHierarchy = (users: any[]) => {
              const map = new Map<number, any>();
              users.forEach(user => {
                map.set(user.id, { ...user, expanded: true, children: [] });
              });
        
              const hierarchy: any = [];
              users.forEach(user => {
                if (user.report === 0) {
                  hierarchy.push(map.get(user.id));
                } else {
                  const parent = map.get(user.report);
                  if (parent) {
                    parent.children.push(map.get(user.id));
                  }
                }
              });

              console.log(hierarchy)
        
              return hierarchy;
            };
        
            this.hierarchicalData = generateHierarchy(uniqueUsers);
            // console.log(JSON.stringify(this.hierarchicalData, null, 2));


        },
        (error: any)=>{
            console.log(error)
        }
    )
  }

}
